import moment from 'moment';

export function getIST(date = false) {
  let currentTime = new Date();
  if (date) {
    currentTime = new Date(date);
  }
  const currentOffset = currentTime.getTimezoneOffset();
  const ISTOffset = 330; // IST offset UTC +5:30
  return new Date(currentTime.getTime() + (ISTOffset + currentOffset) * 60000);
}

export function localDate(date) {
  if (!(date instanceof Date)) {
    if (Number.isNaN(Date.parse(date))) return 'N/A';
    // eslint-disable-next-line no-param-reassign
    date = new Date(date);
  }

  // In IST
  // eslint-disable-next-line no-param-reassign
  date = getIST(date);
  const allMonths = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const month = allMonths[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();
  let hours = date.getHours();
  let minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'pm' : 'am';
  hours %= 12;
  hours = hours || 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? `0${minutes}` : minutes;

  return `${day} ${month} ${year}, ${hours}:${minutes} ${ampm}`;
}

export function getLocalDateInFormat(dt, formate = 'DD/MM/YYYY') {
  const toDt = moment.utc(dt).toDate();
  return moment(toDt).format(formate);
}

export function formatDate(date) {
  if (!date) return '';
  const dateStr = date.slice(0, 16).replace('T', ' ');
  return moment(dateStr, 'YYYY-MM-DD hh:mm').format('DD MMM YYYY hh:mm a');
}
